// This export is for running this helper client-side (without Node)
module.exports = require("./lib/app/sanitize_redirect")
